import './ResourceTabs.scss';
import { useRef, useState, useEffect } from 'react';
import { Icon } from '@gplibraries/react/components';
import { iconMap } from '@gplibraries/react/config';
import ResourceTabsContent from './ResourceTabsContent';
import gsap from "gsap";
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { useGSAP } from '@gsap/react';

export default function ResourceTabMobile(props) {

  const { resources, category, subcategories, activeTab, setActiveTab, containerRef: cref, children } = props;
  const tabRef = useRef();
  const contentRef = useRef();
  const canScroll = useRef(false); // don't scroll on initial page load.
  // if the passed container ref has a current value, we can safely use it. Otherwise,
  // use another ref temporarily so we don't cause errors.
  const containerRef = cref.current ? cref : tabRef;

  gsap.registerPlugin(useGSAP);
  gsap.registerPlugin(ScrollToPlugin);

  // animate opening and closing of tabs
  useGSAP(() => {
    // If this is the active tab and it is not already open, play open animation.
    if (activeTab === category.id) {
      gsap.fromTo(contentRef.current,
        { height: 0 },
        { height: "auto", duration: .5, ease: "power2.out" }
      )

      // scroll to active tab
      if (canScroll.current) {
        gsap.to(window, {
          duration: .5,
          scrollTo: {
            y: tabRef.current,
            offsetY: 150,
            // autoKill: true
          },
          ease: "power2.out"
        });
      }
    }
  }, { scope: tabRef, dependencies: [activeTab] })


  const activateTab = (e) => {
    // prevent default expand/collapse of summary element since we are handling
    // state with react.
    if (e.target.closest('summary')) {
      e.preventDefault();
    }
    // prevent scrolling to tab until another tab has been selected.
    if (!canScroll.current) canScroll.current = true;
    setActiveTab(category.id);
  }

  return (
    <details
      className="resource-details"
      onClick={activateTab}
      ref={tabRef}
      open={activeTab === category.id}
    >

      <summary className={'flex-row resource-tab'}>
        <Icon
          glyph={iconMap.categories[category.id]?.glyph}
          src={iconMap.categories[category.id]?.src}
        />
        {category.name}
      </summary>

      <div className="resource-content-container" ref={contentRef}>

        {/* If we explicitly pass the tab's content, use that. Otherwise, use
         ResourceTabsContent component. */}

        {children
          ? children
          : (
            <ResourceTabsContent
              resources={resources}
              resourceSubcategories={subcategories}
              activeTab={activeTab}
            />
          )
        }



      </div>

    </details>
  );
}